/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithChildren } from "types/fcWithChildren";

export const SearchResultListWrapper: FcWithChildren = (props) => {
  const { children } = props;

  return <div css={rootStyle}>{children}</div>;
};

const rootStyle = css`
  margin-inline: auto;
  max-width: 1018px;
  width: 90%;
`;
